import { render, staticRenderFns } from "./ModalChatContainer.vue?vue&type=template&id=38b4b510&scoped=true&"
import script from "./ModalChatContainer.vue?vue&type=script&lang=js&"
export * from "./ModalChatContainer.vue?vue&type=script&lang=js&"
import style0 from "./ModalChatContainer.vue?vue&type=style&index=0&id=38b4b510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b4b510",
  null
  
)

export default component.exports